import React, { FC } from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OurFleetSection/OurFleetSection.styles';

const OurFleetSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Box className="OFSContent">
        <Container maxWidth="xl">
          {/* Title Container */}
          <Box className="OFSTitleContainer">
            <Box>
              {/* Title Skeleton */}
              <Skeleton variant="text" width={250} height={48} sx={{ mb: 2 }} />
              
              {/* Description Skeleton */}
              <Skeleton variant="text" width="80%" height={24} />
              <Skeleton variant="text" width="70%" height={24} />
            </Box>
            
            {/* Button Skeleton */}
            <Skeleton 
              variant="rectangular" 
              width={150} 
              height={40} 
              sx={{ borderRadius: 1 }} 
              className="ORBFullWidth"
            />
          </Box>

          <Grid container spacing={8}>
            {/* List Section */}
            <Grid item lg={6} md={12} sm={12}>
              <Box>
                {[...Array(5)].map((_, item) => (
                  <Box
                    key={item}
                    className="OFSListItem"
                    sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}
                  >
                    {/* Icon Skeleton */}
                    <Skeleton
                      variant="rectangular"
                      width={24}
                      height={24}
                      sx={{ borderRadius: 1, mr: 2, flexShrink: 0 }}
                    />
                    
                    {/* List Item Text Skeleton */}
                    <Box sx={{ flex: 1 }}>
                      <Skeleton variant="text" width="95%" height={24} />
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>

            {/* Carousel Section */}
            <Grid item xl={6} lg={6} md={12} sm={12} className="OFSSlider">
              <Box sx={{ display: 'flex', gap: 2 }}>
                {[...Array(2)].map((_, item) => (
                  <Box className="CarouselItem" key={item} sx={{ flex: 1 }}>
                    <Box className="OFSBikeCard">
                      {/* Bike Image Skeleton */}
                      <Box>
                        <Skeleton variant="rectangular" width="100%" height={200} />
                      </Box>
                      
                      {/* Text Container */}
                      <Box className="MMSTextContainer">
                        {/* Vehicle Make Skeleton */}
                        <Skeleton variant="text" width="60%" height={24} sx={{ my: 1.25 }} />
                        
                        {/* Model Name Skeleton */}
                        <Skeleton variant="text" width="80%" height={20} />
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </StyledBox>
  );
};

export { OurFleetSectionSkeleton };